<template>
  <div class="root_templateContent" ref="rootref">
    <div>
      <div class="top">
        <!-- <span class="hotlabel">热门搜索：</span> -->
        <div class="search-box">
          <LhSearch
            v-model="keyword"
            :hot-cates="hotCates"
            :carousel-visible="true"
            class-name="templates-search-class"
            name="keywords"
            @searchClick="searchClickHandler"
            @cancelClick="cancelClickHandler"
            @historyClick="historyClickHdl"
          ></LhSearch>
        </div>
      </div>
      <!--分类-->
      <div class="category">
        <cates
          v-bind:specialUrl="'/api/home/category?type=8'"
          :hasChild="true"
          v-on:cateClick="cateClick"
          :style="{ margin: '20px 0 0 5px' }"
          ref="catesControl"
        ></cates>
        <!--过滤信息-->
        <div :class="['cates-wrapper']">
          <div class="direction-radio">
            <span class="title">排序：</span>
            <span
              :class="[sortOrderBy === '11' ? 'active' : '']"
              @click="sortOrderByChanged('11')"
              >推荐</span
            >
            <!-- <div class="division"></div>
            <span
              :class="[sortOrderBy === '0' ? 'active' : '']"
              @click="sortOrderByChanged('0')"
              >最新</span
            > -->
          </div>
          <div class="direction-radio">
            <span class="title">版式：</span>
            <span
              :class="[direction === '1' ? 'active' : '']"
              @click="changeDirection('1')"
              >横版</span
            >
            <div class="division"></div>
            <span
              :class="[direction === '2' ? 'active' : '']"
              @click="changeDirection('2')"
              >竖版</span
            >
          </div>
          <div class="direction-radio">
            <span class="title">价格：</span>
            <span
              :class="[sortPayType === '' ? 'active' : '']"
              @click="sortPayTypeChanged('')"
              >全部</span
            >
            <div class="division"></div>
            <span
              :class="[sortPayType === '0' ? 'active' : '']"
              @click="sortPayTypeChanged('0')"
              >免费</span
            >
            <div class="division"></div>
            <template v-if="IsOldUser">
              <span
                :class="[sortPayType === '1,4' ? 'active' : '']"
                @click="sortPayTypeChanged('1,4')"
                >会员专属</span
              >
              <div class="division"></div>
              <span
                :class="[sortPayType === '6' ? 'active' : '']"
                @click="sortPayTypeChanged('6')"
                >企业会员专属</span
              >
            </template>
            <template v-else>
              <span
                :class="[sortPayType === '6' ? 'active' : '']"
                @click="sortPayTypeChanged('6')"
                >{{ getOptionName(6) }}</span
              >
              <div class="division"></div>
              <span
                :class="[sortPayType === '1,4' ? 'active' : '']"
                @click="sortPayTypeChanged('1,4')"
                >{{ getOptionName(4) }}</span
              >
            </template>
          </div>
          <div class="direction-radio" >
            <span class="title">授权：</span>
            <span
              :class="[sortIsCommerical===''? 'active': '']"
              @click="sortIsCommericalChanged('')"
            >全部</span>
            <div class="division"></div>
            <span
              :class="[sortIsCommerical==='1'? 'active': '']"
              @click="sortIsCommericalChanged('1')"
            >商用</span>
          </div>
          <styleMenu
            class="style-layout"
            v-model="currentStyle"
            :menuList="sortList.style"
            @selectChange="sortStyleChanged"
          ></styleMenu>
          <!-- <div class="sort-style-box">
            <el-select
              v-model="sortStyle"
              placeholder="全部风格"
              popper-class="temp-sort-select"
              @change="sortStyleChanged"
            >
              <el-option
                v-for="item in sortList.style"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>-->
        </div>
      </div>
      <!--列表-->
      <div class="list-div">
        <section class="list" @scroll="loadMore" ref="listdivref">
          <templateItem
            :class="['item', '_' + direction]"
            v-for="(item, idx) in tempList"
            :key="idx"
            :direction="direction"
            :template="item"
            @previewClick="previewClick"
          ></templateItem>
        </section>
        <div class="loading">
          <Loading
            :loading="loadingStatus == 1"
            v-show="loadingStatus == 1"
          ></Loading>
          <div v-show="loadingStatus == 2">没有更多内容了哦</div>
        </div>
        <isEmptyResult v-if="isEmpty"></isEmptyResult>
      </div>
    </div>
    <!--关闭按钮应放在遮罩的下面，否则会引起混乱-->
    <div class="close-lib" @click="closeDialog($event)"></div>

    <div
      class="preview-subwin"
      :style="{ display: selectedItem.id ? 'block' : 'none' }"
    >
      <templatePreview
        :tempItem="selectedItem"
        @CloseTemplibPreview="CloseTemplibPreview"
      ></templatePreview>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import templateItem from "./templateItem";
import templatePreview from "./templatePreview";
import cates from "../common/cates";
import LhSearch from "../common/search";
import isEmptyResult from "../../isEmptyResult";
import styleMenu from "../../dropDownMenu";
import Loading from "@/components/emodal/templateLib/loading";
import vipBadge from '@/components/mixins/vipBadge';

export default {
  mixins: [vipBadge],
  data() {
    return {
      isEmpty: false,
      direction: "1",
      selectedItem: {},
      tempList: [],
      isLoading: false,
      API: {
        category: "/api/home/category?type=8",
        style: "/api/home/style",
        mytemp: "/api/user/template?fPage=16&sOfPage=6",
        hotCate: "/api/common/material/recommendTag",
        temp: "/api/home/template?fPage=19",
        refreshTemp: "/api/common/material?type=8", //&id=temp.checkid
      },
      cateSelected: { name: "全部" },
      currentStyle: {}, //选中的风格
      keyword: "",
      hotCates: [], //搜索框中的热门标签
      totalFee: "", // 支付价格
      showBuy: { display: "none" }, //显示我的购买
      showFavorite: { display: "none" }, //显示我的收藏
      payvisible: false,
      currentTemplate: {}, //当前点击的模板
      direction: "1", //1横2竖
      sortList: {
        style: [
          // {
          //   name: "全部风格",
          //   id: ""
          // }
        ],
      },
      // 0：最新，11：管理后台最优排序
      sortOrderBy: "11",
      // payType：付款类型 0免费  1付费  2付费(优惠价) 3付费(折扣) 4企业专属
      sortPayType: "",
      sortStyle: "",
      sortFileType: "",
      sortIsCommerical: "", //1：可商用；0：不可商用
      sOfPage: "8",
      pIndex: 1,
      loadingStatus: 0,
    };
  },
  methods: {
    closeDialog(e) {
      this.$store.commit("close_TemplateMaterialLibDialogMsg");
    },
    searchClickHandler(keyword) {
      //console.log("TCL: searchClickHandler -> searchClickHandler")
      let query = {};
      if (!this.keyword) this.keyword = "";
      this.cateSelected = { name: "全部" };
      this.loadTempList();
      //console.log("this.keyword => ", this.keyword);
    },
    historyClickHdl(e, keywrod) {
      this.searchClickHandler(keywrod);
    },
    cancelClickHandler() {
      this.cateSelected = { name: "全部" };
      this.sortPayType = "";
      this.sortOrderBy = 11;
      this.loadTempList();
      //console.log("this.keyword => ", this.keyword);
    },
    cateClick(cate) {
      this.keyword = "";
      this.cateSelected = cate;
      this.loadTempList();
      console.log("this.cateSelected", this.cateSelected);
    },
    scrollHandler() {
      //let cateBar = document.querySelector(".wrapper");
      //let header = document.getElementsByTagName("header")[0];
      //let top = header.getBoundingClientRect().top;
      //this.$bus.emit("bus::heaerFix", top <= 0);
    },
    backtotop() {
      //document.body.scrollTop = 360;
      //document.documentElement.scrollTop = 360;
    },
    sortOrderByChanged(type) {
      this.sortOrderBy = type;
      this.loadTempList();
    },
    sortPayTypeChanged(type) {
      this.sortPayType = type;
      this.loadTempList();
    },
    sortStyleChanged(item) {
      //console.log("000000000", idx);
      this.sortStyle = item.id;
      this.loadTempList();
    },
    sortIsCommericalChanged(type) {
      this.sortIsCommerical = type;
      this.loadTempList();
    },
    //横竖屏模板切换
    changeDirection(d) {
      this.direction = d;
      this.loadTempList();
    },
    loadTempList(isLoadMore = false) {
      let url = this.API.temp;
      if (!isLoadMore) this.pIndex = 1;
      //拼接请求参数
      if (this.keyword) {
        url += `&keyword=${this.keyword}`;
      }
      if (this.cateSelected.id) {
        url += `&category=${this.cateSelected.id}`;
      }
      // if (this.sortStyle) {
      //   url += `&style=${this.sortStyle}`;
      // }
      if (this.sortPayType) {
        url += `&payType=${this.sortPayType}`;
      }
      if (this.sortOrderBy) {
        url += `&orderBy=${this.sortOrderBy}`;
      }
      if (this.direction) {
        url += `&direction=${this.direction}`;
      }
      if (this.sortIsCommerical)
        url += `&isCommercial=${this.sortIsCommerical}`;
      if (this.sOfPage) {
        url += `&sOfPage=${this.sOfPage}`;
      }
      if (this.pIndex) {
        url += `&pIndex=${this.pIndex}`;
      }
      if (this.keyword) {
        let decoded = this.$qs.decode(url.split("?")[1]);
        this.$store.commit("tracking/setTrackingData", {
          search_type: "模板搜索",
          keyword: decoded.keyword,
          template_type: "",
        });
      }

      let rooth = this.$refs["rootref"].clientHeight;
      let listdiv = this.$refs["listdivref"];
      let listh = listdiv.parentElement.offsetTop;
      let temph = rooth - listh;
      temph = temph < 10 ? 535 : temph;
      listdiv.style.transition = 'height 0.8s'
      listdiv.style.height = temph - 110 + "px";
      this.loadingStatus = 1;

      //发送请求
      return this.$http.get(url).then(({ data }) => {
        if (this.keyword) {
          let order_methods = {
            "": "推荐",
            "&orderBy=2": "最新",
          };
          let choose_prices = {
            "": "全部",
            "&payType=0": "免费",
            "&payType=1,4": "会员专属",
            "&payType=6": "企业会员专属",
            "&payType=1": "付费",
          };
          let template_types = {
            1: "横版",
            2: "竖版",
          };
          let template_styles = {
            78: "商务科技",
            79: "卡通动漫",
            81: "黑白手绘",
            91: "数据图表",
            92: "实拍视频",
          };
          let payType = "全部";
          if (this.sortPayType == 1) {
            payType = "会员专属";
          } else if (this.sortPayType == 0) {
            payType = "免费";
          }
          sensors.track("classifySearchResult", {
            search_source: "编辑器素材弹窗",
            keyword: this.keyword,
            has_result: !!(data.data && data.data.length),
            material_type: "模板",
            search_type: "素材搜索",
            search_result_num: data.data.length,
            keyword_type: this.trackingData.keyword_type || "手动输入",
            order_method: this.sort ? order_methods[this.sort.value] : "推荐",
            choose_price: this.price ? choose_prices[this.price.value] : "全部",
            select_template_type: template_types[this.direction] || '',
            select_template_style: template_styles[(this.currentStyle || {}).id] || '',
          });
        }


        //解构data
        if (data.code == 200) {
          if (isLoadMore) data.data.forEach((val) => this.tempList.push(val));
          else this.tempList = data.data;
        } else if (isLoadMore && !data.data.length) this.pIndex--; //失败页码还原
        this.isLoading = false;
        this.isEmpty = !(this.tempList && this.tempList.length > 0);

        listdiv.style.transition = 'none'
        this.loadingStatus = 0;
        listdiv.style.height = temph + "px";


        //console.log("模板素材库加载", rooth, listh, temph);
      });
    },
    loadMore(e) {
      //console.log("loadMore() {}");
      //return; //数据测试
      if (this.isLoading) return;
      let scrollTop = e.target.scrollTop;
      let scrollHeight = e.target.scrollHeight;
      let listdiv = this.$refs["listdivref"];
      let contentHeight = listdiv.clientHeight || 0;
      if (scrollTop >= scrollHeight - contentHeight - 5) {
        this.isLoading = true;
        this.pIndex++;
        this.loadTempList(true);
      }
    },
    // handleScroll(e) {
    //   if (this.loadingStatus != 0) {
    //     return;
    //   }
    //   let scrollTop = e.target.scrollTop,
    //     scrollHeight = e.target.scrollHeight,
    //     contentHeight = this.$refs.contentcontainer.clientHeight;
    //   if (scrollTop >= scrollHeight - contentHeight - 5) {
    //     this.pageIndex++;
    //     this.getContentList();
    //   }
    // },
    loadHotCate() {
      //初始化热点
      this.$http.get(this.API.hotCate).then(({ data }) => {
        if (data.code == 200) {
          this.hotCates = data.data;
        }
      });
    },
    previewClick(item) {
      this.selectedItem = item;
    },
    CloseTemplibPreview() {
      this.selectedItem = {};
    },
    activePage(param) {
      this.currentStyle = this.sortList.style.find(
        (e) => e.id === this.StyleDataMsg.id
      );
      if (param) {
        this.direction = param.optimized === "Horizontal" ? "1" : "2";
        this.$refs.catesControl.selectCateById(param.category);
      }
    },
  },
  computed: {
    ...mapGetters(["StyleArrayMsg", "StyleDataMsg", 'IsOldUser']),
    ...mapGetters({
      trackingData: "tracking/trackingData",
    }),
  },
  mounted() {
    if (this.StyleArrayMsg.length > 0) {
      this.sortList.style = this.StyleArrayMsg;
      this.currentStyle = this.sortList.style.find(
        (e) => e.id === this.StyleDataMsg.id
      );
    }
    //console.log("this.StyleDataMsg", this.StyleDataMsg , this.currentStyle);
    //初始化风格
    setTimeout(() => {
      // this.sortList.style = this.sortList.style.concat(this.StyleArrayMsg);
      // this.currentStyle = this.sortList.style.find(
      //   e => e.id === this.StyleDataMsg.id
      // );
      let rooth = this.$refs["rootref"].clientHeight;
      let listdiv = this.$refs["listdivref"];
      let listh = listdiv.parentElement.offsetTop;
      let temph = rooth - listh;
      temph = temph < 10 ? 535 : temph;
      listdiv.style.height = temph + "px";
      console.log("模板素材库加载", rooth, listh, temph);
    }, 3000);

    //初始化热点
    this.$http.get(this.API.hotCate).then(({ data }) => {
      if (data.code == 200) {
        this.hotCates = data.data;
      }
    });
    this.loadTempList();
    //在预览页面，支付完成
    this.$bus.on("template.payDone", (checkId) => {
      if (checkId && this.selectedItem.id) {
        this.$http.get(this.API.refreshTemp + `&id=${checkId}`).then((resp) => {
          if (resp.data.code == 200 && resp.data.data.id) {
            let idx = this.tempList.findIndex((x) => x.id == resp.data.data.id);
            if (idx < 0) return;
            this.tempList[idx] = resp.data.data;
            let copy = this.tempList;
            this.tempList = null;
            this.tempList = copy;
            this.selectedItem = resp.data.data;
          }
        });
      }
    });
  },
  components: {
    templateItem,
    cates,
    LhSearch,
    templatePreview,
    isEmptyResult,
    styleMenu,
    Loading,
  },
};
</script>

<style lang="scss" scoped>
.root_templateContent {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  //border-radius: 0 4px 4px 0;
  overflow: hidden;
  font-size: 12px;
  .top {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    background-color: #f0f0f8;
    width: 100%;
    height: 50px;
    justify-content: flex-end;
    .hotlabel {
      margin-left: 50px;
      margin-right: 230px;
      text-align: left;
      float: right;
      color: #474261;
    }
    .search-box {
      float: right;
      width: 180px;
      height: 32px;
      font-size: 12px;
      margin: 0 56px 0 0;
    }
  }

  .category {
    width: 100%;
    flex-shrink: 0;
    height: auto;
    background-color: white;
    .cates-wrapper {
      height: auto;
      margin: 0 0 0 0px;
      position: relative;
      box-sizing: content-box;
      .direction-radio {
        display: -webkit-flex;
        display: flex;
        float: left;
        margin: 0 0 0 40px;
        color: #0a293f;
        //border-right: 1px solid #c4cad1;
        .active {
          //background-color: #5778fb;
          color: #5778fb;
        }
        & > span {
          cursor: pointer;
          transition: all 0.2s ease;
          display: inline-block;
          &.title {
            margin: 0 14px 0 0;
            font-weight: bold;
          }
        }
        .division {
          opacity: 0.3;
          margin: 1px 12px 0 11px; //上右下左
          width: 0px;
          border-right: 1px solid #c4cad1;
          height: 16px;
          float: left;
        }
      }
    }
  }
  .style-layout {
    float: left;
    height: 30px;
    margin-left: 39px;
  }
  .list-div {
    position: relative;
    float: left;
    width: 100%;
    //height: 550px;
    //overflow-y: auto;
    overflow: hidden;
    background-color: white;
    padding: 16px 0 0px 10px;
    //transition: height 0.8s;
    .list {
      width: 100%;
      overflow-y: auto;
      height: 525px;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding: 0 0 20px 0;
      .item {
        width: 224px;
        margin: 24px 0 0 30px;
        &._1 {
          height: 149px;
        }
        &._2 {
          width: 162px;
          height: 288px;
        }
      }
    }
    .loading {
      height: 110px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #333333;
      line-height: 110px;
    }
  }

  .preview-subwin {
    position: absolute;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
  }

  .close-lib {
    position: absolute;
    width: 16px;
    height: 16px;
    right: 20px;
    top: 17px;
    background-image: url(../../../../../../static/svg/template-material-lib/common/close-1.svg);
    &:hover {
      background-image: url(../../../../../../static/svg/template-material-lib/common/close-active.svg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/contents/template/templateContent.vue